// @ts-nocheck — Swiper and theme globals (fetchConfig, routes, publish, PUB_SUB_EVENTS) loaded externally

function availableEnforceExclusiveCart(productId, newVariantId) {
    return fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
            const updates = {};
            let alreadyAtOne = false;

            cart.items.forEach((item) => {
                const sameProduct = String(item.product_id) === String(productId);
                const sameVariant = String(item.variant_id) === String(newVariantId);

                if (sameVariant && item.quantity === 1) {
                    alreadyAtOne = true;
                } else if (sameVariant && item.quantity !== 1) {
                    updates[item.key] = 1;
                } else if (sameProduct && !sameVariant) {
                    updates[item.key] = 0;
                }
            });

            if (alreadyAtOne && Object.keys(updates).length === 0) {
                return { skip: true };
            }

            if (Object.keys(updates).length === 0) {
                return null;
            }

            return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates }),
                })
                .then((r) => r.json())
                .then(() => (alreadyAtOne ? { skip: true } : null));
        });
}

function initSwiperForSection(section) {
    const swiperEl = section.querySelector('.section-custom-available__swiper');
    if (swiperEl && typeof Swiper !== 'undefined') {
        // Destroy existing instance if present (recommendations re-inject)
        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

        new Swiper(swiperEl, {
            slidesPerView: 1.5,
            spaceBetween: 16,
            navigation: {
                prevEl: section.querySelector('.section-custom-available__nav--prev'),
                nextEl: section.querySelector('.section-custom-available__nav--next'),
            },
            pagination: {
                el: swiperEl.querySelector('.section-custom-available__pagination'),
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },
            breakpoints: {
                750: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                990: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
        });
    }
}

function handleAddToCartClick(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.hasAttribute('aria-disabled')) return;

    const variantId = btn.dataset.variantId;
    const productId = btn.dataset.productId;
    if (!variantId) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    btn.setAttribute('aria-disabled', 'true');

    const doAdd = productId ?
        availableEnforceExclusiveCart(productId, variantId) :
        Promise.resolve(null);

    doAdd
        .then((result) => {
            if (result && result.skip) {
                if (cart && cart.open) cart.open();
                return;
            }

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');

            if (cart) {
                formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
                formData.append('sections_url', window.location.pathname);
                cart.setActiveElement(btn);
            }

            config.body = formData;

            return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
                .then((r) => r.json())
                .then((response) => {
                    if (response.status) {
                        console.error('Cart error:', response);
                        return;
                    }
                    if (!cart) {
                        window.location = (window.routes && window.routes.cart_url) || '/cart';
                        return;
                    }
                    cart.renderContents(response);
                    if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'section-custom-available',
                            productVariantId: variantId,
                            cartData: response,
                        });
                    }
                });
        })
        .catch((e) => console.error(e))
        .finally(() => {
            btn.removeAttribute('aria-disabled');
        });
}

document.querySelectorAll('[data-section-custom-available]').forEach((section) => {
    initSwiperForSection(section);
    section.addEventListener('click', handleAddToCartClick);
});

// Fallback for [data-add-to-cart] buttons outside [data-section-custom-available] (e.g. search results page)
document.addEventListener('click', (e) => {
    if (e.target.closest('[data-section-custom-available]')) return;
    handleAddToCartClick(e);
});

// Re-init swiper after recommendations are injected via fetch
document.addEventListener('recommendations:loaded', (e) => {
    const section = e.target.closest('[data-section-custom-available]');
    if (section) initSwiperForSection(section);
});
